export default "__VITE_ASSET__BveHyVpV__"